<template>
  <div>
    <v-row v-if="prop != null" class="ma-0 my-1 ml-2">
      <div class="ma-0 pa-0 section-sub-item">
        <v-icon size="6" class="pb-1" color="#004662">{{ icon }}</v-icon>
        <span v-html="prop" class="ml-1"></span>
        <span v-if="references && references.length">{{ " " }}</span>
        <v-icon
          @click="setClickedReferences(references)"
          x-small
          v-if="references && references.length"
          class="vetalfa-pointer pb-0"
          color="#004662"
          >{{ mdiInformation }}
        </v-icon>
      </div>
    </v-row>
    <slot></slot>
  </div>
</template>

<style>
.section-sub-item {
  background-color: white;
  width: 100%;
  font-size: 14px;
  font-weight: 0;
  color: #393a3a;
}
</style>

<script>
import { mdiCircleOutline, mdiInformation } from "@mdi/js";
import { mapMutations } from "vuex";
export default {
  name: "SectionSubItem",
  props: {
    prop: {
      type: String,
    },
    references: {
      type: Array,
      default: null,
      required: false,
    },
  },
  methods: {
    ...mapMutations("topics", ["setClickedReferences"]),
  },
  data() {
    return {
      icon: mdiCircleOutline,
      mdiInformation
    };
  },
};
</script>